import React from "react";

export default function Header() {
  return <h1>Welcome to my first stopwatch & timer with React</h1>;
}
